/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type AccountNav_viewer$ref = any;
type CartNav_viewer$ref = any;
type Likes_viewer$ref = any;
type Notifications_initialViewer$ref = any;
type Notifications_viewer$ref = any;
type SearchBar_viewer$ref = any;
export type TopBar_viewer$ref = any;
export type TopBar_viewer = {
    readonly isNotificationsEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly isCartEnabled: boolean | null;
    readonly " $fragmentRefs": AccountNav_viewer$ref & CartNav_viewer$ref & Likes_viewer$ref & Notifications_viewer$ref & Notifications_initialViewer$ref & SearchBar_viewer$ref;
    readonly " $refType": TopBar_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "TopBar_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isNotificationsEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "NOTIFICATIONS"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "FAVORITES"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
        },
        {
            "kind": "ScalarField",
            "alias": "isCartEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "CART"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CART\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "AccountNav_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartNav_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "Likes_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "Notifications_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "Notifications_initialViewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SearchBar_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bffd7bef184744d7259db44e9d3e4c3c';
export default node;
